import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Textarea } from '@/components/ui/textarea'
import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-react'
import { Memory } from '@/types'

const memorySchema = z.object({
  content: z
    .string()
    .min(10, { message: 'Memory content must be at least 10 characters.' }),
})

type MemoryFormValues = z.infer<typeof memorySchema>

interface MemoryFormProps {
  onSubmit: (values: MemoryFormValues) => Promise<void>
  isSubmitting: boolean
  defaultValues?: Memory
  submitButtonText?: string
}

export const MemoryForm = ({
  onSubmit,
  isSubmitting,
  defaultValues,
  submitButtonText = 'Save Memory',
}: MemoryFormProps) => {
  const form = useForm<MemoryFormValues>({
    resolver: zodResolver(memorySchema),
    defaultValues: {
      content: defaultValues?.content || '',
    },
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="content"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Content</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Enter memory details..."
                  className="min-h-[120px]"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="flex justify-end">
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {submitButtonText}
          </Button>
        </div>
      </form>
    </Form>
  )
}
